<template>
  <div>
    <div class="wizard__header" v-html="this.header"></div>

    <form class="wizard__form" ref="form" @submit.prevent="nextClickHandler">
      <div class="row">
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material input-group--required">
            <input class="input-group__textinput" type="text" name="firstName" required v-dirty />
            <label class="input-group__label" for="firstName">First Name</label>
          </div>
        </div>
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material input-group--required">
            <input class="input-group__textinput" type="text" name="lastName" required v-dirty />
            <label class="input-group__label" for="lastName">Last Name</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-12 large-12 columns">
          <div class="wizard__input-group input-group input-group--material input-group--required">
            <input class="input-group__textinput" type="email" name="email" required v-dirty />
            <label class="input-group__label" for="email">Email</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material input-group--required">
            <input class="input-group__textinput" type="tel" name="phoneNumber" required v-dirty />
            <label class="input-group__label" for="phoneNumber">Phone Number</label>
          </div>
        </div>
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material input-group--required input-group--select">
            <input class="input-group__textinput" type="text" name="desiredMoveDate" ref="moveDate" required v-dirty />
            <label class="input-group__label" for="desiredMoveDate">Desired Move Date</label>
          </div>
        </div>
      </div>

      <!-- <br>
      <br> -->

      <div class="row">
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material">
            <input class="input-group__textinput" type="text" name="movingFromAddress" placeholder="" autocomplete="off" v-model="movingFromAddress" ref="autocompleteFrom" v-dirty />
            <label class="input-group__label" for="movingFromAddress">Moving From Address</label>
          </div>
        </div>
        <div class="small-12 medium-6 large-6 columns">
          <div class="row">
            <div class="small-12 medium-6 columns">
              <div class="wizard__input-group input-group input-group--material">
                <input :class="moveFromCityClassObj" type="text" name="movingFromCity" autocomplete="off" v-model="movingFromCity"  />
                <label class="input-group__label" for="movingFromCity">City</label>
              </div>
            </div>
            <div class="small-12 medium-6 columns">
              <div class="row">
                <div class="small-5 columns">
                  <div class="wizard__input-group input-group input-group--select">
                    <select class="input-group__textinput input-group__textinput--select" name="movingFromState" autocomplete="off" v-model="movingFromState" required data-parsley-select>
                      <option value="*">ST*</option>
                      <option value="Alabama">AL</option>
                      <option value="Alaska">AK</option>
                      <option value="Arizona">AZ</option>
                      <option value="Arkansas">AR</option>
                      <option value="California">CA</option>
                      <option value="Colorado">CO</option>
                      <option value="Connecticut">CT</option>
                      <option value="Delaware">DE</option>
                      <option value="Florida">FL</option>
                      <option value="Georgia">GA</option>
                      <option value="Hawaii">HI</option>
                      <option value="Idaho">ID</option>
                      <option value="Illinois">IL</option>
                      <option value="Indiana">IN</option>
                      <option value="Iowa">IA</option>
                      <option value="Kansas">KS</option>
                      <option value="Kentucky">KY</option>
                      <option value="Louisiana">LA</option>
                      <option value="Maine">ME</option>
                      <option value="Maryland">MD</option>
                      <option value="Massachusetts">MA</option>
                      <option value="Michigan">MI</option>
                      <option value="Minnesota">MN</option>
                      <option value="Mississippi">MS</option>
                      <option value="Missouri">MO</option>
                      <option value="Montana">MT</option>
                      <option value="Nebraska">NE</option>
                      <option value="Nevada">NV</option>
                      <option value="New Hampshire">NH</option>
                      <option value="New Jersey">NJ</option>
                      <option value="New Mexico">NM</option>
                      <option value="New York">NY</option>
                      <option value="North Carolina">NC</option>
                      <option value="North Dakota">ND</option>
                      <option value="Ohio">OH</option>
                      <option value="Oklahoma">OK</option>
                      <option value="Oregon">OR</option>
                      <option value="Pennsylvania">PA</option>
                      <option value="Rhode Island">RI</option>
                      <option value="South Carolina">SC</option>
                      <option value="South Dakota">SD</option>
                      <option value="Tennessee">TN</option>
                      <option value="Texas">TX</option>
                      <option value="Utah">UT</option>
                      <option value="Vermont">VT</option>
                      <option value="Virginia">VA</option>
                      <option value="Washington">WA</option>
                      <option value="West Virginia">WV</option>
                      <option value="Wisconsin">WI</option>
                      <option value="Wyoming">WY</option>
                    </select>
                  </div>
                </div>
                <div class="small-7 columns">
                  <div class="wizard__input-group input-group input-group--material input-group--required">
                    <input :class="moveFromZipClassObj" type="text" name="movingFromZip" data-parsley-type="digits" required autocomplete="off" v-model="movingFromZip"  />
                    <label class="input-group__label" for="movingFromZip">Zip</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="small-12 medium-6 large-6 columns">
          <div class="wizard__input-group input-group input-group--material">
            <input class="input-group__textinput" type="text" name="movingToAddress" placeholder="" autocomplete="off" v-model="movingToAddress" ref="autocompleteTo" v-dirty />
            <label class="input-group__label" for="movingToAddress">Moving To Address</label>
          </div>
        </div>
        <div class="small-12 medium-6 large-6 columns">
          <div class="row">
            <div class="small-12 medium-6 columns">
              <div class="wizard__input-group input-group input-group--material">
                <input :class="moveToCityClassObj" type="text" name="movingToCity" autocomplete="off" v-model="movingToCity"  />
                <label class="input-group__label" for="movingToCity">City</label>
              </div>
            </div>
            <div class="small-12 medium-6 columns">
              <div class="row">
                <div class="small-5 columns">
                  <div class="wizard__input-group input-group input-group--select">
                    <select class="input-group__textinput input-group__textinput--select" name="movingToState" autocomplete="off" v-model="movingToState" required data-parsley-select>
                      <option value="*">ST *</option>
                      <option value="Alabama">AL</option>
                      <option value="Alaska">AK</option>
                      <option value="Arizona">AZ</option>
                      <option value="Arkansas">AR</option>
                      <option value="California">CA</option>
                      <option value="Colorado">CO</option>
                      <option value="Connecticut">CT</option>
                      <option value="Delaware">DE</option>
                      <option value="Florida">FL</option>
                      <option value="Georgia">GA</option>
                      <option value="Hawaii">HI</option>
                      <option value="Idaho">ID</option>
                      <option value="Illinois">IL</option>
                      <option value="Indiana">IN</option>
                      <option value="Iowa">IA</option>
                      <option value="Kansas">KS</option>
                      <option value="Kentucky">KY</option>
                      <option value="Louisiana">LA</option>
                      <option value="Maine">ME</option>
                      <option value="Maryland">MD</option>
                      <option value="Massachusetts">MA</option>
                      <option value="Michigan">MI</option>
                      <option value="Minnesota">MN</option>
                      <option value="Mississippi">MS</option>
                      <option value="Missouri">MO</option>
                      <option value="Montana">MT</option>
                      <option value="Nebraska">NE</option>
                      <option value="Nevada">NV</option>
                      <option value="New Hampshire">NH</option>
                      <option value="New Jersey">NJ</option>
                      <option value="New Mexico">NM</option>
                      <option value="New York">NY</option>
                      <option value="North Carolina">NC</option>
                      <option value="North Dakota">ND</option>
                      <option value="Ohio">OH</option>
                      <option value="Oklahoma">OK</option>
                      <option value="Oregon">OR</option>
                      <option value="Pennsylvania">PA</option>
                      <option value="Rhode Island">RI</option>
                      <option value="South Carolina">SC</option>
                      <option value="South Dakota">SD</option>
                      <option value="Tennessee">TN</option>
                      <option value="Texas">TX</option>
                      <option value="Utah">UT</option>
                      <option value="Vermont">VT</option>
                      <option value="Virginia">VA</option>
                      <option value="Washington">WA</option>
                      <option value="West Virginia">WV</option>
                      <option value="Wisconsin">WI</option>
                      <option value="Wyoming">WY</option>
                    </select>
                  </div>
                </div>
                <div class="small-7 columns">
                  <div class="wizard__input-group input-group input-group--material input-group--required">
                    <input :class="moveToZipClassObj" type="text" name="movingToZip" data-parsley-type="digits" required autocomplete="off" v-model="movingToZip"  />
                    <label class="input-group__label" for="movingToZip">Zip</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
          <div class="small-12 medium-6 large-6 columns">
              <div class="wizard__input-group input-group input-group--select">
                  <select class="input-group__textinput input-group__textinput--select" name="howDidYouHearAboutUs" required data-parsley-select>
                    <option value="" selected="" disabled>How Did You Hear About Us? *</option>
                    <option value="Email">Email</option>
                    <option value="Previous Customer">Previous Customer</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Google Search">Google Search</option>
                    <option value="Google Ads">Google Ads</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Saw Truck/Movers">Saw Truck/Movers</option>        
                    <option value="Word of Mouth">Word of Mouth</option>
                    <option value="Yelp">Yelp</option>
                    <option value="Other">Other</option>
                  </select>
              </div>
          </div>
          <div class="small-12 medium-6 large-6 columns">
              <div class="wizard__input-group input-group input-group--material" :class="{ tall: promoCode != '' }">
                <input class="input-group__textinput" v-model="promoCode" type="text" name="promoCode" v-dirty />
                <ul class="info-notice" v-if="promoCode != ''"><li><strong>Please note:</strong> Discounts from promo codes are not applied until your Formal Quote or until the time of booking.</li></ul>
                <label class="input-group__label" for="promoCode">Promo Code</label>
              </div>
          </div>
      </div>

      <div class="row">
          <div class="small-12 medium-12 large-12 columns" style="text-align:left;">
            <div class="wizard__input-group input-group input-group--material">
              <input type="checkbox" name="emailOptIn" id="emailOptIn" v-dirty/>
              <label for="emailOptIn">Get updates and special offers from New Latitude.</label>
            </div>
          </div>
      </div>

    </form>

    <ul class="wizard__nav" v-if="onPrevious">
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li>
      <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--next" @click.prevent="nextClickHandler">Get Price</a></li>
    </ul>
  </div>
</template>

<script>
  import $ from 'jquery';
  import flatpickr from 'flatpickr';
  import parsley from 'parsleyjs';
  import { serialize } from 'dom-form-serializer';

  Parsley.addValidator('select', {
    validateString: function(value) {
      return value !== "*" ? true : false;
    }
  });

  export default {
    props: {
      onResponse: {
        type: Function
      },

      onPrevious: {
        type: Function
      },

      header: {
        type: String
      }
    },

    data: () => ({
      name: 'movingDetails',
      movingFromAddress:'',
      movingFromCity:'',
      movingFromState:'*',
      movingFromZip:'',
      movingToAddress:'',
      movingToCity:'',
      movingToState:'*',
      movingToZip:'',
      promoCode:''
    }),

    computed: {
      moveToZipClassObj() {
            if(this.movingToZip !== '') {
                return 'input-group__textinput is-dirty';
            } else {
                return 'input-group__textinput';
            }
        },
        moveToCityClassObj() {
            if(this.movingToCity !== '') {
                return 'input-group__textinput is-dirty';
            } else {
                return 'input-group__textinput';
            }
        },
        moveFromZipClassObj() {
            if(this.movingFromZip !== '') {
                return 'input-group__textinput is-dirty';
            } else {
                return 'input-group__textinput';
            }
        },
        moveFromCityClassObj() {
            if(this.movingFromCity !== '') {
                return 'input-group__textinput is-dirty';
            } else {
                return 'input-group__textinput';
            }
        }
    },

    mounted() {
      let _this = this;
      flatpickr(this.$refs.moveDate, {
        minDate: new Date().fp_incr(1),
        dateFormat: 'F d, Y',
        disableMobile: 'true'
      });

      google.maps.event.addDomListener(window, 'load', function() {

        //Google Places Autocomplete

        // Initiate Autocomplete for From Address Field
        _this.autocompleteFrom = new google.maps.places.Autocomplete(
            (_this.$refs.autocompleteFrom),
            {types: ['geocode']}
        );

        _this.autocompleteFrom.addListener('place_changed', () => {
            let place = _this.autocompleteFrom.getPlace();
            let address = place.address_components;
            let streetNumber = address.filter(adr => {
                return adr.types.includes("street_number");
            });
            let streetName = address.filter(adr => {
                return adr.types.includes("route");
            });
            let city = address.filter(adr => {
                return adr.types.includes("locality");
            });
            let state = address.filter(adr => {
                return adr.types.includes("administrative_area_level_1");
            });
            let zip = address.filter(adr => {
                return adr.types.includes("postal_code");
            });

            // Set Moving From Address Params
            _this.movingFromAddress = `${ streetNumber[0].short_name } ${ streetName[0].short_name }`;
            _this.movingFromCity = city[0].short_name;
            _this.movingFromState = state[0].long_name;
            _this.movingFromZip = zip[0].short_name;
        });

        // Initiate Autocomplete for To Address Field
        _this.autocompleteTo = new google.maps.places.Autocomplete(
            (_this.$refs.autocompleteTo),
            {types: ['geocode']}
        );

        _this.autocompleteTo.addListener('place_changed', () => {
            let place = _this.autocompleteTo.getPlace();
            let address = place.address_components; 

            let streetNumber = address.filter(adr => {
                return adr.types.includes("street_number");
            });
            let streetName = address.filter(adr => {
                return adr.types.includes("route");
            });
            let city = address.filter(adr => {
                return adr.types.includes("locality");
            });
            let state = address.filter(adr => {
                return adr.types.includes("administrative_area_level_1");
            });
            let zip = address.filter(adr => {
                return adr.types.includes("postal_code");
            });

            // Set Moving To Address Params
            _this.movingToAddress = `${ streetNumber[0].short_name } ${ streetName[0].short_name }`;
            _this.movingToCity = city[0].short_name;
            _this.movingToState = state[0].long_name;
            _this.movingToZip = zip[0].short_name;
        });
      });
    },

    methods: {
      nextClickHandler() {
        if (! $(this.$refs.form).parsley().validate())
          return;

        let $form = this.$refs.form;
        let data = serialize($form);
        let zipWhiteList = [
            '35007',
            '35020',
            '35022',
            '35040',
            '35043',
            '35061',
            '35064',
            '35068',
            '35071',
            '35115',
            '35117',
            '35124',
            '35125',
            '35147',
            '35080',
            '35094',
            '35114',

            // Trussville
            '35173',

            // Tuscaloosa
            '35404',
            '35403',
            '35487',
            '35407',
            '35402',
            '35486',
            '35478',
            '35473',
            '35476',
            '35401',
            '35453',
            '35405',
            '35406',
            '35449',
            '35456',
            '35452',
            '35463',
            '35468',
            '35446',
            '35482',
            '35490',
            '35475',
            '35444',
            '35457',
            '35440',
            '35480',
            '35188',
            '35474',
            '35184',
            '35458',
            '35074',
            '35006',
            '35111',
            '35469',
            '35034',
            '35466',
            '35441',
            '35546',
            '35023',
            '35042',

            // Auburn
            '36832',
            '36865',
            '36849',
            '36830',
            '36831',
            '36866',
            '36879',
            '36087',
            '36802',
            '36803',
            '36801',
            '36088',
            '36804',
            '36083',
            '36850',
            '36023',
            '36078',
            '36853',
            '36874',
            '36045',
            '36039',
            '36852',
            '36860',
            '36075',
            '36858',
            '36862',
            '36031',
            '36854',
            '36861',
            '36024',
            '36870',
            '36877',
            '36872',
            '36863',
            '36013',
            '36869',
            '36875',
            '36089',
            '36849',
        ];
        let movingFromZip = data.movingFromZip;
        let movingToZip = data.movingToZip;
        let localZip = movingFromZip.startsWith('352') || zipWhiteList.includes(movingFromZip);
        let outsideZip = movingToZip.startsWith('352') || zipWhiteList.includes(movingToZip);

        let response = 'Local Zip';
        if(!localZip || !outsideZip) {
          response = 'Long Zip';
        }

        if (! this.onResponse) return;

        this.onResponse({
          data: {
            ...data,
            zipDistance: (response == 'Local Zip') ? 'Local' : 'Long Distance',
            request: true
          },
          response
        });
      }
    }
  };
</script>
